import React from 'react';
import Icon from '../../../components/AppIcon';

const AntiBiasToggle = ({ isEnabled, onToggle }) => {
  return (
    <div className="bg-card rounded-xl p-6 shadow-elevation border border-border">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Shield" size={20} className="text-primary" />
            <h3 className="text-lg font-semibold text-foreground">Anti-Bias Mode</h3>
          </div>
          <p className="text-sm text-muted-foreground mb-4">
            Hide sensitive demographic information to promote fair, skills-based hiring. 
            This removes age, gender, photo, and other potentially biasing factors from your profile.
          </p>
          
          <div className="space-y-2 mb-4">
            <div className="flex items-center space-x-2 text-sm">
              <Icon name="Check" size={16} className="text-success" />
              <span className="text-muted-foreground">Reduces unconscious bias</span>
            </div>
            <div className="flex items-center space-x-2 text-sm">
              <Icon name="Check" size={16} className="text-success" />
              <span className="text-muted-foreground">Focus on skills and experience</span>
            </div>
            <div className="flex items-center space-x-2 text-sm">
              <Icon name="Check" size={16} className="text-success" />
              <span className="text-muted-foreground">Promotes equal opportunities</span>
            </div>
          </div>
        </div>
        
        <div className="flex-shrink-0 ml-4">
          <button
            onClick={onToggle}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
              isEnabled ? 'bg-primary' : 'bg-muted'
            }`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                isEnabled ? 'translate-x-6' : 'translate-x-1'
              }`}
            />
          </button>
        </div>
      </div>
      
      <div className={`mt-4 p-3 rounded-lg border ${
        isEnabled 
          ? 'bg-success/5 border-success/20 text-success' :'bg-muted/30 border-border text-muted-foreground'
      }`}>
        <div className="flex items-center space-x-2 text-sm">
          <Icon name={isEnabled ? "ShieldCheck" : "Shield"} size={16} />
          <span>
            {isEnabled 
              ? "Anti-bias mode is active - demographic info hidden" :"Anti-bias mode is disabled - full profile visible"
            }
          </span>
        </div>
      </div>
    </div>
  );
};

export default AntiBiasToggle;